module.exports = __webpack_public_path__ + "static/media/marker.330ce496.png";